import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CommonActions, CommonActionTypes } from './common.actions';
import { CommonState, FsOrgState, LoadingState } from '../../../reducers';

const initialState: CommonState = {
  notifications: {},
  notificationsState: LoadingState.INIT,
};

export function CommonReducer(state: CommonState = initialState, action: CommonActions = null): CommonState {
  switch (action.type) {
    case CommonActionTypes.LoadNotifications:
      return { ...state, notificationsState: LoadingState.LOADING };
    case CommonActionTypes.LoadNotificationsSuccess:
      return {
        ...state,
        notifications: action.payload.response ? action.payload.response.values : {},
        notificationsState: LoadingState.LOADED,
      };
    case CommonActionTypes.LoadNotificationsFailure:
      return { ...state, notifications: {}, notificationsState: action.payload.response.error };
    case CommonActionTypes.DismissTutorialNotification: {
      const notifications = { ...state.notifications, ...action.payload };
      return { ...state, notifications };
    }
    case CommonActionTypes.ResetTutorialNotification:
      return { ...state, notifications: {} };
    default: {
      return state;
    }
  }
}

export const commonFeature = createFeatureSelector<FsOrgState, CommonState>('common');

export const userNotifications = createSelector(
  commonFeature,
  (state: CommonState) => ({
    notifications: state.notifications,
    state: state.notificationsState,
  }),
);
